export const ACTION_GET_VISIT_TYPES = 'ACTION_GET_VISIT_TYPES'
export const ACTION_GET_DEFAULT_INSTITUTION = 'ACTION_GET_DEFAULT_INSTITUTION'
export const ACTION_GET_VISIT_TIMES = 'ACTION_GET_VISIT_TIMES'
export const ACTION_BOOK_APPOINTMENT = 'ACTION_BOOK_APPOINTMENT'

export const SET_VISIT_TYPE_LIST = 'SET_VISIT_TYPE_LIST'
export const SET_INSTITUTION = 'SET_INSTITUTION'
export const SET_VISIT_TIME_LIST = 'SET_VISIT_TIME_LIST'
export const SET_BOOK_RESULT = 'SET_BOOK_RESULT'
export const RESET_APPOINTMENT_STATE = 'RESET_APPOINTMENT_STATE'

export const VISIT_TYPE_LIST_KEY = 'visitTypeList'
export const INSTITUTION_KEY = 'institution'
export const VISIT_TIME_LIST_KEY = 'visitTimeList'
export const BOOK_RESULT_KEY = 'bookResult'
